<div class="flex h-[calc(100dvh)] items-center justify-center">
  <h1 class="text-3xl" i18n>404 - Page not found</h1>
</div>
